import FilterChip from 'LuxKit/Chips/FilterChip'
import type { OfferPagePriceMode } from 'contexts/OfferPage/offerPageStateReducer'
import { OfferPageActions, offerPagePriceModes } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import useToggle from 'hooks/useToggle'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'
import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import { useMemo, useRef } from 'react'
import { useIntl } from 'react-intl'

function usePriceModeLabels(): Record<OfferPagePriceMode, string> {
  const intl = useIntl()
  return useMemo(() => ({
    total: intl.formatMessage({
      id: 'Q53zkKrHVNO-Jxj6MSHY',
      defaultMessage: 'Total price',
    }),
    perPerson: intl.formatMessage({
      id: 'UE5pYS57Wzu9z_M7jRhd',
      defaultMessage: 'Price per person',
    }),
  }), [intl])
}

interface Props {
  priceMode: OfferPagePriceMode
}

function PriceModeSelectMobile({ priceMode }: Props) {
  const { value: isOpen, toggle, off: close } = useToggle()
  const anchorRef = useRef<HTMLButtonElement>(null)
  const dispatch = useOfferPageDispatch()
  const priceModeLabels = usePriceModeLabels()

  const setMode = (newMode: OfferPagePriceMode) => {
    dispatch({ type: OfferPageActions.setPriceMode, priceMode: newMode })
    close()
  }

  return <>
    <FilterChip size="medium" endIcon={<LineAngleDownIcon />} onClick={toggle} ref={anchorRef}>
      {priceModeLabels[priceMode]}
    </FilterChip>
    <DropdownList size="S" open={isOpen} onClose={close} anchorRef={anchorRef} triggerRef={anchorRef} placement="bottom-end">
      {offerPagePriceModes.map(mode => <ClickableListItem key={mode} title={priceModeLabels[mode]} onClick={() => setMode(mode)} />)}
    </DropdownList>
  </>
}

type MappedProps = Pick<Props, 'priceMode'>

export default withOfferPageState((state): MappedProps => ({
  priceMode: state.priceMode,
}), PriceModeSelectMobile)
